import { Fragment, useMemo, useState } from 'react';
import { useGetFaceplatesQuery } from '../../utils/callApis';
import { Box, Grid } from '@material-ui/core';
import Paper from '@mui/material/Paper';
import FaceplateOptionList from './FaceplatesOptionList';
import MobileFaceplatesList from './MobileFaceplatesList';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from 'react-redux';
import layout from '../../styles/layout.module.css';

export const FaceplatesMaterialList = ({ width }) => {
    const activeFaceplateType = useSelector(
        (state) => state.rootReducer.currentFaceplateType.activeFaceplateType
    );
    const { data: faceplateOption, isLoading, isSuccess, isError, error } = useGetFaceplatesQuery();
    const [selected, setSelected] = useState(activeFaceplateType ? activeFaceplateType : null);
    const faceplateOptionKeys = useMemo(
        () => (faceplateOption ? Object.keys(faceplateOption) : []),
        [faceplateOption]
    );
    let content;

    if (isLoading) {
        content = (
            <Box className={layout.loaderContainer}>
                <CircularProgress />
            </Box>
        );
    } else if (isSuccess) {
        if (width < 800) {
            content = (
                <MobileFaceplatesList
                    faceplateOption={faceplateOption}
                    setSelected={setSelected}
                    selected={selected}
                />
            );
        } else {
            //Loads component that contains Button and list
            const materialList = faceplateOptionKeys.map((option) => {
                const variants = faceplateOption[option];
                return (
                    <Fragment key={option}>
                        <FaceplateOptionList
                            activeFaceplateType={activeFaceplateType}
                            title={option}
                            faceplates={variants}
                        />
                    </Fragment>
                );
            });

            content = (
                <Paper elevation={0} className={layout.excerptContainer}>
                    <Box>
                        <Grid
                            container
                            direction="column"
                            style={{ width: '100%', flexWrap: 'nowrap', gap: '10px' }}>
                            {materialList}
                        </Grid>
                    </Box>
                </Paper>
            );
        }
    } else if (isError) {
        content = <div>{error.toString()}</div>;
    }

    return <>{content}</>;
};
